import React, { useEffect, useState } from "react";

interface Props {
  threshold?: number; // TODO: Use enum type for media queries
  aboveThreshold?: React.JSX.Element | React.JSX.Element[] | string;
  belowThreshold?: React.JSX.Element | React.JSX.Element[] | string;
}

export const ResponsiveComponent: React.FC<React.PropsWithChildren<Props>> = ({
  threshold = 1024,
  aboveThreshold,
  belowThreshold,
}) => {
  const [width, setWidth] = useState(window.innerWidth);

  function isScreenLargerThanOrEqual(threshold: number): boolean {
    return width >= threshold;
  }

  useEffect(() => {
    const listener = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", listener);
    return () => {
      window.removeEventListener("resize", listener);
    };
  }, []);

  if (isScreenLargerThanOrEqual(threshold)) {
    return <>{aboveThreshold}</>;
  }
  return <>{!!belowThreshold && belowThreshold}</>;
};
